import { put, select } from "redux-saga/effects";
import { getZapierTokensFailure, getZapierTokensSuccess } from "../actionCreators";
import { IntegrationService } from "../integration.service";
import { GetZapierTokensRequestActionType } from "../types";

export function* handleGetZapierTokens(action: GetZapierTokensRequestActionType) {
    try {
        const formId: string = yield select(state => state.forms.current._id);
        const { data } = yield IntegrationService.getZapierTokens(formId);

        yield put(
            getZapierTokensSuccess({
                success: true,
                message: "Zapier tokens retrieved successfully",
                data: data.token,
            }),
        );
    } catch (error: any) {
        const errorMessage = error.response?.data?.message || "Failed to get Zapier tokens";
        yield put(getZapierTokensFailure(errorMessage));
    }
}
